import { Link } from 'react-router-dom';
import { ctaData } from '@/mocks/home';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-primary-500 p-10 md:p-14 text-center">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-white" />
            <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-white" />
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              {ctaData.title}
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-8 max-w-lg mx-auto">
              {ctaData.description}
            </p>
            <Link
              to="/category/recommended"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-primary-600 font-semibold rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i>
              {ctaData.buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}